import { Box, NavList, TreeView, TreeViewSubTreeProps } from '@primer/react';
import styles from "./Menu.module.css";
import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import { IMenuViewModel } from '../model/response/auth/IMenuViewModel';
import { useAuth } from '../hooks/useAuth';
import { useAppSelector } from '../hooks/useAppSelector';
import { useMemo } from 'react';
interface ISubMenuProps extends TreeViewSubTreeProps {
    menuParent: IMenuViewModel,
    key?: string
}
const NavItem = ({ to, children, defaultOpen }: any) => {
    const resolved = useResolvedPath(to)
    const isCurrent = useMatch({ path: resolved.pathname, end: true })
    return (
        <NavList.Item as={Link} to={to} aria-current={isCurrent ? 'page' : undefined} defaultOpen={defaultOpen}>
            {children}
        </NavList.Item>
    )
}
const Menu = () => {
    const { user } = useAuth();
const { moduleSelected } = useAppSelector(x => x.common.layout);

    const menus = useMemo(() => {
        const menuAll = user?.menus ?? [];
        if (moduleSelected) {
            return menuAll.filter(x => x.id === moduleSelected.id || moduleSelected.name === "Tất cả");
        }
        return menuAll;
    }, [moduleSelected, user?.menus]);
    return (
        <div style={{ marginBottom: 0 }} className={styles.menu}>
            <NavList className={styles.menuTitle}>
                {menus.filter(x => x.menu_id_parent === "0" || x.menu_id_parent === "" || x.menu_id_parent === "00000000-0000-0000-0000-000000000000").map(group => {
                    return (
                        <NavList.Group title={group.name} key={group.id}>
                            {group.items.map(menu => {
                                return (
                                    <NavItem to={`../../../${menu.path}`} key={menu.id} defaultOpen={menu.items.length > 0 ? false : undefined}>
                                        <NavList.LeadingVisual>
                                            {menu.icon &&
                                                // <img src={`../../images/${menu.icon}`} alt='icon' style={{
                                                //     width: "16px"
                                                // }} />
                                                <i className={`${menu.icon}`}></i>
                                            }
                                        </NavList.LeadingVisual>    
                                        {menu.name}
                                        {menu.items.length > 0 &&
                                            <NavList.SubNav>
                                                {menu.items.map(s => {
                                                    return (
                                                        <NavItem key={s.id} to={`../../../${s.path}`}  className={styles.menu_sub_item}>

                                                        <NavList.LeadingVisual>
                                                                {/* {s.icon &&
                                                                    <img src={`../../images/${s.icon}`} alt='icon' style={{
                                                                        width: "16px"
                                                                    }} />
                                                                } */}
                                                                <i className='fas fa-ellipsis-v'></i>
                                                               {/* <span className={styles.menu_sub_item_icon}></span> */}
                                                            </NavList.LeadingVisual>
                                                        <span className={styles.menu_sub_item}>
                                                        {s.name}
                                                        </span>
                                                        </NavItem>
                                                    )
                                                })}
                                            </NavList.SubNav>
                                        }
                                    </NavItem>


                                );
                            })}
                        </NavList.Group>
                    );
                })}
                {/* <NavList.Group title={moduleSelected?.name} key={moduleSelected?.id}>
                    {menus.map(menu => {
                        return (
                            <NavItem to={`../../../${menu.path}`} key={menu.id} defaultOpen={menu.items.length > 0 ? true : undefined}>
                                <NavList.LeadingVisual>

                                    <img src={`../../images/${menu.icon}`} alt='icon' style={{
                                        width: "16px"
                                    }} />
                                </NavList.LeadingVisual>
                                {menu.name}
                                {menu.items.length > 0 &&
                                    <NavList.SubNav>
                                        {menu.items.map(s => {
                                            return (
                                                <NavItem key={s.id} to={`../../../${s.path}`}>

                                                    <NavList.LeadingVisual>
                                                        {s.icon &&
                                                            <img src={`../../images/${s.icon}`} alt='icon' style={{
                                                                width: "16px"
                                                            }} />
                                                        }
                                                    </NavList.LeadingVisual>

                                                    {s.name}

                                                </NavItem>
                                            )
                                        })}
                                    </NavList.SubNav>
                                }
                            </NavItem>

                          
                        );
                    })}
                </NavList.Group> */}

            </NavList>
             
        </div>
        
    );
};
const SubMenu = (props: ISubMenuProps) => {
    const { menuParent } = props;


    return (
        <>
            {menuParent.items.length > 0 &&
                <>
                    {menuParent.items.map(menu => {
                        return (
                            <TreeView.Item key={menu.id} id={menu.id.toString()}
                                current={menu.id === "1"}
                                onSelect={() => {
                                    // history.push(`../../${menu.path}`)
                                }}
                            >
                                {menu.icon &&
                                    <TreeView.LeadingVisual>
                                        <img src={`../../images/${menu.icon}`} alt='icon' style={{
                                            width: "16px"
                                        }} />
                                    </TreeView.LeadingVisual>
                                }
                                <Link to={`../../${menu.path}`} className='link'>
                                    {menu.name}
                                </Link>
                                <SubMenu menuParent={menu} />

                            </TreeView.Item>
                        )
                    })}

                </>
            }
        </>
    )
}

export default Menu;